import type { ToolId } from "./tools.js";
import { useStudioStore } from "./StudioStoreContext.js";

/**
 * Small cart button pinned to the top-right of every editor tool panel.
 * Tapping it opens the in-editor Studio Bag store scrolled to this tool's
 * category, where the player can buy more options for the tool. Owned options
 * always stay usable in the panel itself; the cart is purely "get more".
 */
export function ToolCartButton({ tool }: { tool: ToolId }) {
  const store = useStudioStore();
  return (
    <button
      type="button"
      className="tool-cart-btn"
      data-testid={`tool-cart-${tool}`}
      aria-label="Open the Studio Bag store for this tool"
      title="Get more in the Studio Bag"
      onClick={() => store.openStore({ tool })}
    >
      <span className="tool-cart-glyph" aria-hidden>
        🛒
      </span>
    </button>
  );
}
